import { render, staticRenderFns } from "./LabelDesigner.vue?vue&type=template&id=e4edef56&scoped=true&"
import script from "./LabelDesigner.vue?vue&type=script&lang=js&"
export * from "./LabelDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4edef56",
  null
  
)

export default component.exports